import { Grid, Box, Container, Stack, Typography } from "@mui/material";
import KpiCard from "../../components/ui/kpiCard";
import Page from "../../components/Page";
import { InsightsGrid } from "./ui/insight/InsightGrid";
import { InsightsActions } from "./ui/insight/InsightsActions";



export default function Insights() {
    return (
        <Page title="Analyse">
            <Container sx={{ marginTop: { xs: 3, sm: 0 } }}>
                <Stack spacing={5}>
                    <Box>
                        <Typography variant="h4">Insights IA</Typography>
                        <Typography color={'text.secondary'} fontSize={16}>Recommandations intelligentes générées par IA pour optimiser vos performances.</Typography>
                    </Box>
                    <Box>
                        <InsightsGrid />
                        <InsightsActions />
                    </Box>
                </Stack>

            </Container>

        </Page>

    );
}
